// Icon mappings from react-icons/io5 and fa (brands)
import type { CSSProperties, SVGProps } from 'react';
import {
  IoCalendar,
  IoCalendarOutline,
  IoCall,
  IoChevronBack,
  IoChevronForward,
  IoChevronDown,
  IoChevronUp,
  IoImageOutline,
  IoLinkOutline,
  IoLocationOutline,
  IoPricetag,
  IoPricetagOutline,
  IoSearchOutline,
  IoTrashOutline,
  IoTime,
  IoTimeOutline,
} from 'react-icons/io5';
import { FaFacebook, FaFacebookMessenger, FaInstagram, FaTelegram, FaVk } from 'react-icons/fa';
import { FaTiktok, FaViber, FaWhatsapp, FaXTwitter, FaYoutube } from 'react-icons/fa6';
import { MdLocationOn } from 'react-icons/md';
// Мессенджер Max — логотип из public/max-logo.svg, окрашивается в currentColor (как остальные иконки)
const MAX_LOGO_URL = '/max-logo.svg';
function IconMax(props: SVGProps<SVGSVGElement> & { size?: number }) {
  const { size = 24, style, ...rest } = props;
  const s = typeof size === 'number' ? size : 24;
  return (
    <span
      role="img"
      style={{
        display: 'inline-block',
        width: s,
        height: s,
        maskImage: `url(${MAX_LOGO_URL})`,
        maskSize: 'contain',
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        WebkitMaskImage: `url(${MAX_LOGO_URL})`,
        WebkitMaskSize: 'contain',
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        backgroundColor: 'currentColor',
        ...(style as CSSProperties),
      }}
      {...(rest as object)}
    />
  );
}

// All available icons as const map for type safety
export const ICONS = {
  // Content types
  calendar: IoCalendar,
  calendarOutline: IoCalendarOutline,
  services: IoPricetagOutline,
  tag: IoPricetagOutline,

  // UI elements
  phone: IoCall,
  location: IoLocationOutline,
  image: IoImageOutline,
  link: IoLinkOutline,
  time: IoTime,
  timeOutline: IoTimeOutline,
  chevronRight: IoChevronForward,
  chevronLeft: IoChevronBack,
  chevronDown: IoChevronDown,
  chevronUp: IoChevronUp,
  search: IoSearchOutline,
  trash: IoTrashOutline,

  // Social / brands
  vk: FaVk,
  telegram: FaTelegram,
  instagram: FaInstagram,
  facebook: FaFacebook,
  tiktok: FaTiktok,
  youtube: FaYoutube,
  xTwitter: FaXTwitter,
  whatsapp: FaWhatsapp,
  viber: FaViber,
  messenger: FaFacebookMessenger,
  max: IconMax,
  googleMaps: MdLocationOn,
  yandexMaps: MdLocationOn,
  twoGis: MdLocationOn,
  avito: IoPricetag,
} as const;

// Type-safe icon names
export type IconName = keyof typeof ICONS;
